import { uniqBy } from 'lodash';
import { BaseCollection } from './../../../common/services/base-collection';
/**
 * @deprecated PeopleCollection is deprecated and has to be removed withing
 * https://doxyme.atlassian.net/browse/CS-8573
 */
export class PeopleCollection extends BaseCollection {
    addOrReplace(person) {
        const existingPerson = this.findByUid(person.uuid);
        if (existingPerson) {
            this.remove(existingPerson);
        }
        this.add(person);
    }
    findByUid(uid) {
        return this.findOne((p) => p.uuid === uid);
    }
    getPatients() {
        return this.find((person) => person.isPatient());
    }
    getDoctors() {
        return this.find((person) => person.isDoctor());
    }
    getUniqDoctors() {
        return uniqBy(this.getDoctors(), (doctor) => doctor.getUserId());
    }
}
